import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

import UniqueDiscountCodeCard from '../../admin/components/setting/UniqueDiscountCodeCard';
import GeneralDiscountCodeCard from '../../admin/components/setting/GeneralDiscountCodeCard';

const DiscountCode = ({ token, client }) => {

    const history = useHistory();

    const { t } = useTranslation();

    const [toggled, setToggled] = useState(false);
    const [distributorId, setDistributorId] = useState("");
    const [country, setCountry] = useState("Malaysia");
    const [outletList, setOutletList] = useState([])

    useEffect(() => {
        if (!client || !client.discount_code) {
            history.push('/client')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    const handleSelectDistributor = (e) => {
        setDistributorId(e.target.value);
        setCountry(client.distributor.filter(distributor => distributor.id === e.target.value)[0].country)
        setOutletList(client.outlet.filter(outlet => outlet.distributorId === e.target.value))
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />

            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />

                <div className="admin-content">

                    <div className="text-center">
                        <h3>{t("Discount Code")}</h3>
                    </div>
                    <div className="pb-2">
                        <label htmlFor="distributorId">{t("Select Distributor")}: </label>
                        <select id="distributorId" name="distributorId" className="browser-default form-select" value={distributorId} onChange={e => handleSelectDistributor(e)}>
                            <option disabled value="">{t("Select Distributor")}</option>
                            {
                                client.distributor.map(distributor => <option key={distributor.id} value={distributor.id}>{distributor.name}</option>)
                            }
                        </select>
                    </div>

                    {
                        distributorId ? (
                            <div>
                                <GeneralDiscountCodeCard id={distributorId} role="distributor" token={token} country={country} outlets={outletList} />
                                <UniqueDiscountCodeCard id={distributorId} role="distributor" token={token} country={country} outlets={outletList} />
                            </div>
                        ) : null
                    }
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(DiscountCode);